import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15069d33"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15069d33')) {
      api.createRecord('15069d33', component.options)
    } else {
      api.reload('15069d33', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=15069d33", function () {
      api.rerender('15069d33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/authentication/index.vue"
export default component.exports